<template>
  <div>
    <el-form-item
      :label="$t('Product.dataType')"
      prop="dataType"
      :rules="[{ required: true, message: $t('Product.dataType'), trigger: 'change' }]"
    >
      <el-select v-model="form.dataType" filterable :placeholder="$t('Product.dataType')">
        <el-option v-for="item in _dataTypeOptions" :key="item" :label="item" :value="item">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('Product.lengthType')" prop="lengthType">
      <el-select v-model="form.lengthType" filterable :placeholder="$t('Product.lengthType')">
        <el-option v-for="item in lengthTypeOptions" :key="item" :label="item" :value="item">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      :label="$t('Product.specsLength')"
      prop="specs.length"
      v-if="form.dataType !== 'text' && form.dataType !== 'array'"
    >
      <el-input-number
        v-model="form.specs.length"
        :min="0"
        :max="10240"
        :controls="false"
        :precision="0"
        style="margin-right: 8px;"
      ></el-input-number>
    </el-form-item>
    <!-- int float double -->
    <template v-if="isNumberType">
      <el-form-item :label="$t('Product.dataRange')" class="multiple-form-item ranges-form-item">
        <div class="multiple-form-item-content">
          <!-- int -->
          <template v-if="form.dataType === 'int'">
            <el-form-item
              prop="specs.min"
              :rules="[{ validator: validateIntMinMax, trigger: 'blur' }]"
              ref="minItem"
            >
              <el-input v-model="form.specs.min" :placeholder="$t('Common.tipsInput1')"></el-input>
            </el-form-item>
            <span class="union">~</span>
            <el-form-item
              prop="specs.max"
              :rules="[{ validator: validateIntMinMax, trigger: 'blur' }]"
              ref="maxItem"
            >
              <el-input v-model="form.specs.max" :placeholder="$t('Common.tipsInput1')"></el-input>
            </el-form-item>
          </template>
          <!-- float -->
          <template v-if="form.dataType === 'float'">
            <el-form-item
              prop="specs.min"
              :rules="[{ validator: validateFloatMinMax, trigger: 'blur' }]"
              ref="minItem"
            >
              <el-input v-model="form.specs.min" :placeholder="$t('Common.tipsInput1')"></el-input>
            </el-form-item>
            <span class="union">~</span>
            <el-form-item
              prop="specs.max"
              :rules="[{ validator: validateFloatMinMax, trigger: 'blur' }]"
              ref="maxItem"
            >
              <el-input v-model="form.specs.max" :placeholder="$t('Common.tipsInput1')"></el-input>
            </el-form-item>
          </template>
          <!-- double -->
          <template v-if="form.dataType === 'double'">
            <el-form-item
              prop="specs.min"
              :rules="[{ validator: validateDoubleMinMax, trigger: 'blur' }]"
              ref="minItem"
            >
              <el-input v-model="form.specs.min" :placeholder="$t('Common.tipsInput1')"></el-input>
            </el-form-item>
            <span class="union">~</span>
            <el-form-item
              prop="specs.max"
              :rules="[{ validator: validateDoubleMinMax, trigger: 'blur' }]"
              ref="maxItem"
            >
              <el-input v-model="form.specs.max" :placeholder="$t('Common.tipsInput1')"></el-input>
            </el-form-item>
          </template>
        </div>
      </el-form-item>
      <el-form-item :label="$t('Common.unit2')" prop="specs.unit">
        <el-input v-model="form.specs.unit" :placeholder="$t('Common.unit2')"></el-input>
        <!-- <el-select v-model="form.specs.unit" filterable placeholder="单位">
          <el-option
            v-for="item in unitOptions"
            :key="item.unit"
            :label="item.name"
            :value="item.unit"
          >
          </el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item :label="$t('Product.coefficient')" prop="specs.coefficient">
        <el-input
          v-model="form.specs.coefficient"
          :placeholder="$t('Product.coefficient')"
          @input="onlyNonNegative"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('Product.step')" prop="specs.step">
        <el-input
          v-model="form.specs.step"
          :placeholder="$t('Product.step')"
          @input="onlyStepNonNegative"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('Product.hasSigned')" prop="specs.signed">
        <el-radio-group v-model="form.specs.signed">
          <el-radio :label="true">{{ $t('Product.hasSignedY') }}</el-radio>
          <el-radio :label="false">{{ $t('Product.hasSignedN') }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </template>
    <!-- enum -->
    <template v-if="isEnumType">
      <el-form-item :label="$t('Product.elementType')" prop="specs.type">
        <el-radio-group v-model="form.specs.type">
          <el-radio label="int">int</el-radio>
          <el-radio label="text">text</el-radio>
          <el-radio label="bit">bit</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        :label="$t('Product.enumDesc')"
        prop="specs.enumDesc"
        class="form-item--bg enum-form-item"
      >
        <div style="display: flex">
          <div class="form-item-content--bg list">
            <div class="enum-item list-header">
              <div class="enum-left">
                {{ $t('Product.param') }}
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="
                    `${$t('Product.tips14')}${Number.MIN_SAFE_INTEGER} ~ ${Number.MAX_SAFE_INTEGER}`
                  "
                  placement="top"
                >
                  <svg class="icon">
                    <use xlink:href="#icon-question1"></use>
                  </svg>
                </el-tooltip>
              </div>
              <div class="enum-right">
                {{ $t('Product.paramDes') }}
                <el-tooltip class="item" effect="dark" placement="top">
                  <svg class="icon">
                    <use xlink:href="#icon-question1"></use>
                  </svg>
                  <template slot="content">
                    <p style="line-height: 22px;">
                      {{ $t('Product.tips8') }}<br />
                      {{ $t('Product.tips15') }}
                    </p></template
                  >
                </el-tooltip>
              </div>
            </div>
            <div
              class="enum-item list-item"
              v-for="(enumItem, index) in form.specs.enumDescArr"
              :key="index"
            >
              <div class="enum-left">
                <el-form-item
                  label=""
                  :prop="`specs.enumDescArr[${index}].key`"
                  :rules="[{ validator: validateEnumKey, trigger: 'blur' }]"
                >
                  <el-input-number
                    v-if="form.specs.type === 'int'"
                    v-model="enumItem.key"
                    :min="Number.MIN_SAFE_INTEGER"
                    :max="Number.MAX_SAFE_INTEGER"
                    :controls="false"
                    :precision="0"
                    style="width: 100%;"
                  ></el-input-number>
                  <el-input
                    v-else
                    v-model="enumItem.key"
                    :placeholder="$t('Common.tipsInput1')"
                    style="width: 100%;"
                  >
                  </el-input>
                </el-form-item>
              </div>
              <div class="enum-right">
                <el-form-item
                  label=""
                  :prop="`specs.enumDescArr[${index}].value`"
                  :rules="[{ validator: validateEnumValue, trigger: 'blur' }]"
                >
                  <el-input v-model="enumItem.value" style="width: 100%;"> </el-input>
                </el-form-item>
              </div>
              <span class="del">
                <svg class="icon" @click="handleEnumItemDel(index)">
                  <use xlink:href="#icon-del_16"></use>
                </svg>
              </span>
            </div>
            <div class="add-btn" @click="handleEnumItemAdd">
              <svg class="icon">
                <use xlink:href="#icon-add"></use>
              </svg>
              <span>{{ $t('Product.addParam') }}</span>
            </div>
          </div>
          <div style="margin-top: 10px;margin-left: 8px">
            <hl-button type="text" @click="enumSetLang">{{ $t('Common.setLang') }}</hl-button>
          </div>
        </div>
      </el-form-item>
      <EnumSetLang
        :row="enumLangRow"
        :enumNameContent="enumNameContent"
        v-if="visibleEnumLang"
        @enumSaveLang="enumSaveLang"
        :visible.sync="visibleEnumLang"
      ></EnumSetLang>
    </template>
    <!-- bool -->
    <template v-if="isBoolType">
      <el-form-item :label="$t('Product.bool')" prop="specs.enumDesc" class="form-item--bg">
        <div class="form-item-content--bg">
          <el-form-item label="false:" prop="specs.enumDesc[0]" label-width="80px">
            <el-input
              v-model="form.specs.enumDesc[0]"
              :placeholder="$t('Common.maxLengthTips16')"
              style="width: 367px;"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="true:"
            prop="specs.enumDesc[1]"
            label-width="80px"
            style="margin-bottom: 0;"
          >
            <el-input
              v-model="form.specs.enumDesc[1]"
              :placeholder="$t('Common.maxLengthTips16')"
              style="width: 367px;"
            ></el-input>
          </el-form-item>
        </div>
      </el-form-item>
    </template>
    <!-- text -->
    <template v-if="isTextType">
      <el-form-item prop="specs.length">
        <template slot="label">
          <el-tooltip class="item" effect="dark" placement="right-start" :visible-arrow="false">
            <span>
              {{ $t('Product.dataLength') }}
              <svg class="icon">
                <use xlink:href="#icon-question1"></use></svg
            ></span>
            <template slot="content"> {{ $t('Product.max') }}：10240 </template>
          </el-tooltip>
        </template>
        <el-input-number
          v-model="form.specs.length"
          :min="0"
          :max="10240"
          :controls="false"
          :precision="0"
          style="margin-right: 8px;"
        ></el-input-number>
        {{ $t('Product.bite') }}
      </el-form-item>
    </template>
    <!-- struct -->
    <template v-if="isStructType">
      <!--      <JsonParamsFormItem-->
      <!--        :label="$t('Product.JSONObject')"-->
      <!--        v-model="form"-->
      <!--        :needComplexDatatype="!needComplexDatatype"-->
      <!--      />-->
      <JsonParamsFromSelect
        :label="$t('Product.structObjects')"
        v-model="form"
        needComplexDatatype
        jsonProps="structObjects"
      />
    </template>
    <!-- array -->
    <template v-if="isArrayType">
      <el-form-item :label="$t('Product.elementType')" prop="specs.type">
        <el-radio-group v-model="form.specs.type">
          <el-radio :label="item" v-for="item in arrayDatatypeOptions" :key="item">
            {{ item }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="specs.size">
        <template slot="label">
          <el-tooltip class="item" effect="dark" placement="right-start" :visible-arrow="false">
            <span>
              {{ $t('Product.eleNum') }}
              <svg class="icon">
                <use xlink:href="#icon-question1"></use></svg
            ></span>
            <template slot="content"> {{ $t('Product.max') }}：512 </template>
          </el-tooltip>
        </template>
        <el-input-number
          v-model="form.specs.length"
          :min="0"
          :max="512"
          :controls="false"
          :precision="0"
        ></el-input-number>
      </el-form-item>
      <JsonParamsFormItem
        v-if="form.specs.type === 'struct'"
        :label="$t('Product.JSONObject')"
        v-model="form"
        :needComplexDatatype="!needComplexDatatype"
      />
    </template>
  </div>
</template>

<script>
import BigNumber from 'bignumber.js'
import JsonParamsFormItem from './JsonParamsFormItem'
import JsonParamsFromSelect from './JsonParamsFromSelect'
import { intergerReg, numberReg } from '@/utils/regex'
import { dataTypeOptions, unitOptions, arrayDatatypeOptions, lengthTypeOptions } from './data.js'
const INT_MIN_VALUE = -2147483648
const INT_MAX_VALUE = 2147483648
const FLOAT_MIN_VALUE = -'340282346638528860000000000000000000000'
const FLOAT_MAX_VALUE = '340282346638528860000000000000000000000'
const DOUBLE_MIN_VALUE = Number.MIN_VALUE
const DOUBLE_MAX_VALUE = Number.MAX_VALUE
import EnumSetLang from './EnumSetLang'
export default {
  name: 'DataTypeFormItem',
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object
    },
    needComplexDatatype: {
      type: Boolean,
      default: true
    }
  },
  components: {
    JsonParamsFormItem,
    EnumSetLang,
    JsonParamsFromSelect
  },
  data() {
    return {
      enumLangRow: [],
      enumNameContent: [],
      visibleEnumLang: false,
      lengthTypeOptions,
      dataTypeOptions,
      unitOptions,
      arrayDatatypeOptions,
      jsonVisible: false,
      currJson: {
        specs: {
          enumDesc: { 0: '', 1: '' },
          enumDescArr: [{ key: undefined, value: '' }],
          enumNameContent: []
        }
      },
      currJsonIndex: -1
    }
  },
  created() {
    this.formatData()
  },
  computed: {
    isNumberType() {
      return (
        this.form.dataType === 'int' ||
        this.form.dataType === 'float' ||
        this.form.dataType === 'double'
      )
    },
    isTextType() {
      return this.form.dataType === 'text'
    },
    isEnumType() {
      return this.form.dataType === 'enum'
    },
    isBoolType() {
      return this.form.dataType === 'bool'
    },
    isStructType() {
      return this.form.dataType === 'struct'
    },
    isArrayType() {
      return this.form.dataType === 'array'
    },
    _dataTypeOptions() {
      if (this.needComplexDatatype) {
        return dataTypeOptions
      }
      return dataTypeOptions.filter((item) => item !== 'array' && item !== 'struct')
    }
  },
  watch: {
    'form.dataType'(val) {
      if (val) {
        this.formatData()
      }
    }
  },
  methods: {
    onlyNonNegative(value) {
      console.log('value', value)
      //清除“数字”和“.”以外的字符
      //   .replace(/[^\d^\.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
      let newValue =
        ('' + value) // 第一步：转成字符串
          .replace(/[^0-9.]/g, '') // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,1})/g)[0] || '' // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，
      console.log('value', value)
      this.$set(this.form.specs, 'coefficient', newValue)
    },
    onlyStepNonNegative(value) {
      console.log('value', value)
      //清除“数字”和“.”以外的字符
      //   .replace(/[^\d^\.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
      let newValue =
        ('' + value) // 第一步：转成字符串
          .replace(/[^0-9.]/g, '') // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,1})/g)[0] || '' // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，
      console.log('value', value)
      this.$set(this.form.specs, 'step', newValue)
    },
    enumSetLang() {
      if (
        this.form.specs.enumDescArr.length > 0 &&
        this.form.specs.enumDescArr.every(
          (name) => name.key !== '' && name.key !== null && name.key !== null
        )
      ) {
        this.visibleEnumLang = true
        this.enumLangRow = JSON.parse(JSON.stringify(this.form.specs.enumDescArr))
        this.enumNameContent = JSON.parse(JSON.stringify(this.form.specs.enumNameContent))
      } else {
        this.$message.warning(`${this.$t('Product.tips16')}`)
      }
    },
    enumSaveLang(data) {
      this.$set(this.form.specs, 'enumNameContent', data.enumNameContent)
    },
    formatData() {
      const specs = JSON.parse(JSON.stringify(this.form.specs))
      //const specs = this.form.specs
      const enumDescArr = []
      let enumDesc = {}
      if (this.form.dataType === 'enum') {
        if (specs.enumDesc && Object.keys(specs.enumDesc).length > 0) {
          for (const key in specs.enumDesc) {
            enumDescArr.push({
              key,
              value: specs.enumDesc[key]
            })
          }
        } else {
          enumDescArr.push({ key: undefined, value: '' })
        }
        this.form.specs.enumNameContent = this.form.specs.enumNameContent || []
      } else if (this.form.dataType === 'bool') {
        if (specs.enumDesc && Object.keys(specs.enumDesc).length > 0) {
          enumDesc = specs.enumDesc
        } else {
          enumDesc = { 0: '', 1: '' }
        }
      }
      console.log('enumDescArr', enumDescArr)
      this.form.specs.enumDesc = enumDesc
      // this.form.specs.enumDescArr = enumDescArr
      this.$set(this.form.specs, 'enumDescArr', enumDescArr)
    },
    validateIntMinMax(rule, value, callback) {
      // 1、判断是否有值，没有值不用校验，有值继续校验
      if (value == null || value === '') {
        callback()
      } else {
        // 2、是否是整数
        if (!intergerReg.test(value)) {
          return callback(new Error(`${this.$t('Product.tips17')}`))
        }
        // 3、取值范围判断
        if (value < INT_MIN_VALUE || value > INT_MAX_VALUE) {
          return callback(
            new Error(`${this.$t('Product.dataRange')}：${INT_MIN_VALUE} - ${INT_MAX_VALUE}`)
          )
        }
        // 4、最大值与最小值的判断
        if (
          (this.form.specs.max || this.form.specs.max === 0) &&
          Number(this.form.specs.min) >= Number(this.form.specs.max)
        ) {
          return callback(new Error(`${this.$t('Product.tips18')}`))
        }
        callback()
      }
    },
    validateFloatMinMax(rule, value, callback) {
      // 1、判断是否有值，没有值不用校验，有值继续校验
      if (value == null || value === '') {
        callback()
      } else {
        // 2、是否是整数
        if (!numberReg.test(value)) {
          return callback(new Error(`${this.$t('Product.tips19')}`))
        }
        // 3、取值范围判断
        if (
          new BigNumber(value).isLessThan(new BigNumber(FLOAT_MIN_VALUE)) ||
          new BigNumber(value).isGreaterThan(new BigNumber(FLOAT_MAX_VALUE))
        ) {
          return callback(
            new Error(`${this.$t('Product.dataRange')}：${FLOAT_MIN_VALUE} - ${FLOAT_MAX_VALUE}`)
          )
        }
        // 4、最大值与最小值的判断
        if (
          (this.form.specs.max || this.form.specs.max === 0) &&
          new BigNumber(this.form.specs.min) >= new BigNumber(this.form.specs.max)
        ) {
          return callback(new Error(`${this.$t('Product.tips18')}`))
        }
        callback()
      }
    },
    validateDoubleMinMax(rule, value, callback) {
      // 1、判断是否有值，没有值不用校验，有值继续校验
      if (value == null || value === '') {
        callback()
      } else {
        // 2、是否是整数
        if (!numberReg.test(value)) {
          return callback(new Error(`${this.$t('Product.tips19')}`))
        }
        // 3、取值范围判断
        if (
          new BigNumber(value).isLessThan(new BigNumber(DOUBLE_MIN_VALUE)) ||
          new BigNumber(value).isGreaterThan(new BigNumber(DOUBLE_MAX_VALUE))
        ) {
          return callback(
            new Error(`${this.$t('Product.dataRange')}：${DOUBLE_MIN_VALUE} - ${DOUBLE_MAX_VALUE}`)
          )
        }
        // 4、最大值与最小值的判断
        if (
          (this.form.specs.max || this.form.specs.max === 0) &&
          new BigNumber(this.form.specs.min) >= new BigNumber(this.form.specs.max)
        ) {
          return callback(new Error(`${this.$t('Product.tips18')}`))
        }
        callback()
      }
    },
    validateEnumKey(rule, value, callback) {
      if (this.form.specs.type === 'int') {
        if (value !== '' && value != null && !intergerReg.test(value)) {
          return callback(new Error(`${this.$t('Product.tips17')}`))
        }
      }
      callback()
    },
    validateEnumValue(rule, value, callback) {
      if (value === '' || value == null) {
        callback()
      } else if (!/^[a-zA-Z0-9\u4e00-\u9fa5]+[\u4e00-\u9fa5\w-\s*]*$/.test(value)) {
        callback(new Error(`${this.$t('Product.tips20')}`))
      } else {
        callback()
      }
    },
    handleEnumItemAdd() {
      if (!this.form.specs.enumDescArr) {
        this.form.specs.enumDescArr = []
      }
      this.form.specs.enumDescArr.push({
        key: undefined,
        value: ''
      })
    },
    handleEnumItemDel(index) {
      this.form.specs.enumDescArr.splice(index, 1)
    },
    handnleJsonAdd() {
      this.currJson = {
        specs: {
          enumDesc: { 0: '', 1: '' },
          enumDescArr: [{ key: undefined, value: '' }]
        }
      }
      this.currJsonIndex = -1
      this.jsonVisible = true
    },
    handleJsonEdit(json, index) {
      this.currJson = json
      this.currJsonIndex = index
      this.jsonVisible = true
    },
    handleJsonDel(index) {
      this.form.specs.item.splice(index, 1)
    },
    handleJsonSave(json) {
      if (!this.form.specs.item) {
        this.form.specs.item = []
      }
      if (this.currJsonIndex === -1) {
        // 新增
        this.form.specs.item.push(json)
      } else {
        this.form.specs.item.splice(this.currJsonIndex, 1, json)
      }
      this.jsonVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  color: $--color-blue;
  font-size: 16px;
  cursor: pointer;
}
/deep/.form-item-content--bg {
  width: 580px;
  padding: 16px;
  background: #f4f8fe;
  border-radius: 0px 16px 16px 16px;
}
.multiple-form-item-content {
  display: flex;
  .el-form-item {
    margin-bottom: 0;
  }
}
.ranges-form-item {
  /deep/ {
    .el-form-item__content {
      width: 200px;
    }
    .el-input {
      width: 100%;
    }
    .el-form-item__error {
      position: static;
      line-height: 14px;
    }
  }
}
.union {
  margin: 0 10px;
}
/deep/.add-btn {
  margin-top: 8px;
  width: 520px;
  line-height: 1;
  text-align: center;
  padding: 6px 0;
  border: 2px dashed rgba(218, 223, 230, 1);
  border-radius: 4px;
  font-size: 14px;
  color: $--color-blue;
  cursor: pointer;
  .icon {
    margin-right: 1px;
  }
}
.el-input-number {
  /deep/ .el-input__inner {
    text-align: left;
  }
}
.list {
  .list-header {
    display: flex;
    color: #333333;
  }
  .list-item {
    display: flex;
  }
}
.enum-item {
  .enum-left {
    width: 160px;
  }
  .enum-right {
    width: 340px;
    margin-left: 24px;
    margin-right: 11px;
  }
  .el-form-item {
    margin-bottom: 16px;
    &.is-error {
      margin-bottom: 28px;
    }
  }
}
// .struct-form-item {
//   .list {
//     padding-right: 40px;
//   }
//   .add-btn {
//     width: 100%;
//     margin-top: 16px;
//   }
//   .struct-item {
//     padding-left: 25px;
//     &.list-item {
//       background-color: #fff;
//       margin-bottom: 4px;
//       height: 40px;
//       line-height: 40px;
//     }
//     .struct-left {
//       width: 360px;
//     }
//     .struct-right {
//       width: 160px;
//     }
//   }
// }
</style>
